import React from "react";

import Button from "../elements/Button.tsx";
import Header from "../elements/Header.tsx";
import Modal, { ModalProps } from "../elements/Modal.tsx";

interface CartWarningModalProps extends Pick<ModalProps, "onClose"> {
  justHappened?: boolean;
}

const CartWarningModal: React.FC<CartWarningModalProps> = ({
  onClose,
  justHappened = false,
}) => {
  const goToCart = () => {
    window.open("/cart", "_blank");
    onClose();
  };

  return (
    <Modal onClose={onClose}>
      <Header size="2xl" hideUnderline className="mb-4">
        {"FYI: You've got something in your cart already"}
      </Header>
      <div className="mb-4">
        {justHappened ? (
          <>
            You can&apos;t submit your upgrade because you already have items in
            your cart. Complete your current purchase or empty your cart to
            proceed.
          </>
        ) : (
          <>
            You can still build your upgrade, but you won&apos;t be able to
            submit it until you&apos;ve checked out or removed the current items
            in your cart.
          </>
        )}
      </div>
      <Button onClick={() => goToCart()}>View Cart</Button>
    </Modal>
  );
};

export default CartWarningModal;
